/**
 * Course videos
 *
 * Click-to-play facade for private Vimeo embeds. No iframe is created until
 * the visitor asks for one, so a page with seven videos does not download
 * seven Vimeo player bundles on load.
 *
 * The embed URL must already carry its privacy hash (?h=...). The section
 * validates that server side; this file only appends player parameters.
 */
(function () {
  'use strict';

  var LOAD_TIMEOUT_MS = 15000;

  function buildPlayerUrl(rawUrl) {
    // Preserve the existing query string, which holds the ?h= privacy hash.
    var separator = rawUrl.indexOf('?') === -1 ? '?' : '&';
    return rawUrl + separator + 'autoplay=1&byline=0&portrait=0&title=0&dnt=1';
  }

  class MmmCourseVideosElement extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      var facade = event.target.closest('[data-video-facade]');
      if (!facade || !this.contains(facade)) return;

      event.preventDefault();
      this.play(facade);
    }

    play(facade) {
      var frame = facade.closest('[data-video-frame]');
      if (!frame) return;

      var embedUrl = frame.getAttribute('data-embed-url');
      if (!embedUrl) return;

      var title = frame.getAttribute('data-video-title') || 'Course video';
      var errorEl = frame.parentNode.querySelector('[data-video-error]');

      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', buildPlayerUrl(embedUrl));
      iframe.setAttribute('title', title);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');

      var loaded = false;
      var timer = window.setTimeout(function () {
        if (loaded || !errorEl) return;
        errorEl.hidden = false;
      }, LOAD_TIMEOUT_MS);

      iframe.addEventListener('load', function () {
        loaded = true;
        window.clearTimeout(timer);
      });

      iframe.addEventListener('error', function () {
        window.clearTimeout(timer);
        if (errorEl) errorEl.hidden = false;
      });

      facade.remove();
      frame.appendChild(iframe);

      // Keyboard users land back on the player rather than the top of the page.
      iframe.setAttribute('tabindex', '-1');
      if (typeof iframe.focus === 'function') iframe.focus({ preventScroll: true });
    }
  }

  if (!window.customElements.get('mmm-course-videos')) {
    window.customElements.define('mmm-course-videos', MmmCourseVideosElement);
  }
})();
